module.exports = __webpack_public_path__ + "static/media/logo.4ed3e374.svg";